import React from "react";
import {
    FaBolt,
    FaMoneyBillWave,
    FaRocket,
    FaSyncAlt
} from "react-icons/fa";

const CrossPlatformHero = () => {

    const features = [
        {
            icon: <FaBolt />,
            title: "Faster Development",
            desc: "Build Android and iOS applications simultaneously with a single codebase."
        },
        {
            icon: <FaMoneyBillWave />,
            title: "Cost Effective",
            desc: "Reduce development and maintenance costs without compromising quality."
        },
        {
            icon: <FaRocket />,
            title: "Faster Launch",
            desc: "Reach the market quicker with streamlined development workflows."
        },
        {
            icon: <FaSyncAlt />,
            title: "Easy Maintenance",
            desc: "Manage one codebase and deploy updates across multiple platforms."
        }
    ];

    return (
        <>
            <section className="wcp-section">

                <div className="wcp-glow wcp-glow-1"></div>
                <div className="wcp-glow wcp-glow-2"></div>

                <div className="wcp-container">

                    {/* LEFT */}

                    <div className="wcp-content">

                        <div className="wcp-badge">
                            CROSS-PLATFORM
                        </div>

                        <h2>
                            One Codebase.
                            <br />
                            <span>Unlimited Possibilities.</span>
                        </h2>

                        <p>
                            Cross-platform development allows businesses to
                            launch powerful applications on Android and iOS
                            using a single codebase, reducing costs while
                            maintaining premium user experiences.
                        </p>

                        <div className="wcp-stats">

                            <div>
                                <h3>50%</h3>
                                <span>Lower Cost</span>
                            </div>

                            <div>
                                <h3>2X</h3>
                                <span>Faster Delivery</span>
                            </div>

                            <div>
                                <h3>100%</h3>
                                <span>Code Reusability</span>
                            </div>

                        </div>

                    </div>

                    {/* RIGHT */}

                    <div className="wcp-visual">

                        <div className="wcp-phone">

                            <div className="wcp-screen">

                                <div className="wcp-logo">
                                    ⚡
                                </div>

                                <h4>
                                    Cross Platform
                                </h4>

                                <p>
                                    Android + iOS
                                </p>

                            </div>

                        </div>

                    </div>

                </div>

                {/* FEATURES */}

                <div className="wcp-features">

                    {features.map((item, index) => (

                        <div
                            key={index}
                            className="wcp-feature"
                        >

                            <div className="wcp-icon">
                                {item.icon}
                            </div>

                            <h3>
                                {item.title}
                            </h3>

                            <p>
                                {item.desc}
                            </p>

                        </div>

                    ))}

                </div>

                <style>{`

                .wcp-section{
                    position:relative;
                    overflow:hidden;
                    padding:140px 24px;
                    background:
                    linear-gradient(
                        180deg,
                        #ffffff 0%,
                        #fff7f7 50%,
                        #ffffff 100%
                    );
                }

                .wcp-container{
                    max-width:1400px;
                    margin:auto;
                    display:grid;
                    grid-template-columns:1fr 1fr;
                    gap:80px;
                    align-items:center;
                    position:relative;
                    z-index:2;
                }

                .wcp-badge{
                    display:inline-flex;
                    padding:12px 22px;
                    border-radius:999px;
                    background:rgba(232,33,42,.08);
                    color:#E8212A;
                    font-size:13px;
                    font-weight:700;
                    margin-bottom:24px;
                    font-family:'Plus Jakarta Sans',sans-serif;
                }

                .wcp-content h2{
                    font-size:clamp(50px,6vw,90px);
                    line-height:.95;
                    color:#111;
                    font-weight:800;
                    margin-bottom:25px;
                    letter-spacing:-4px;
                    font-family:'Syne',sans-serif;
                }

                .wcp-content h2 span{
                    background:
                    linear-gradient(
                        135deg,
                        #E8212A,
                        #FF4D4D
                    );
                    -webkit-background-clip:text;
                    -webkit-text-fill-color:transparent;
                }

                .wcp-content p{
                    font-size:18px;
                    line-height:1.9;
                    color:#666;
                    max-width:650px;
                    margin-bottom:40px;
                    font-family:'Plus Jakarta Sans',sans-serif;
                }

                .wcp-stats{
                    display:flex;
                    gap:20px;
                    flex-wrap:wrap;
                }

                .wcp-stats div{
                    background:#fff;
                    padding:22px 28px;
                    border-radius:22px;
                    border:1px solid #eee;
                    box-shadow:
                    0 10px 30px rgba(0,0,0,.05);
                }

                .wcp-stats h3{
                    font-size:34px;
                    margin:0;
                    color:#111;
                    font-family:'Syne',sans-serif;
                }

                .wcp-stats span{
                    color:#777;
                    font-size:14px;
                }

                .wcp-visual{
                    position:relative;
                    height:650px;
                }

                .wcp-phone{
                    position:absolute;
                  left: 10%;
                    transform:translate(-50%,-50%);
                    width:310px;
                    height:620px;
                    padding:12px;
                    border-radius:42px;
                    background:#111;
                    box-shadow:
                    0 40px 100px rgba(232,33,42,.15);
                    animation:floatPhone 5s ease-in-out infinite;
                }

                .wcp-screen{
                    width:100%;
                    height:100%;
                    border-radius:32px;
                    background:
                    linear-gradient(
                        135deg,
                        #E8212A,
                        #FF4D4D
                    );
                    display:flex;
                    flex-direction:column;
                    align-items:center;
                    justify-content:center;
                    color:#fff;
                }

                .wcp-logo{
                    width:90px;
                    height:90px;
                    border-radius:24px;
                    background:
                    rgba(255,255,255,.18);
                    display:flex;
                    align-items:center;
                    justify-content:center;
                    font-size:42px;
                    margin-bottom:24px;
                    backdrop-filter:blur(12px);
                }

                .wcp-screen h4{
                    font-size:34px;
                    margin-bottom:10px;
                    font-family:'Syne',sans-serif;
                }

                .wcp-card{
                    position:absolute;
                    background:#fff;
                    padding:16px 22px;
                    border-radius:18px;
                    font-weight:700;
                    box-shadow:
                    0 20px 40px rgba(0,0,0,.08);
                    animation:floatCard 4s ease-in-out infinite;
                }

                .card-1{
                    top:80px;
                    left:20px;
                }

                .card-2{
                    top:120px;
                    right:20px;
                }

                .card-3{
                    bottom:120px;
                    left:20px;
                }

                .card-4{
                    bottom:80px;
                    right:20px;
                }

                .wcp-features{
                    max-width:1400px;
                    margin:100px auto 0;
                    display:grid;
                    grid-template-columns:repeat(4,1fr);
                    gap:24px;
                }

                .wcp-feature{
                    background:#fff;
                    padding:35px;
                    border-radius:28px;
                    border:1px solid #eee;
                    transition:.4s ease;
                    box-shadow:
                    0 10px 30px rgba(0,0,0,.04);
                }

                .wcp-feature:hover{
                    transform:translateY(-10px);
                    box-shadow:
                    0 25px 60px rgba(232,33,42,.12);
                }

                .wcp-icon{
                    width:70px;
                    height:70px;
                    border-radius:20px;
                    background:
                    linear-gradient(
                        135deg,
                        #E8212A,
                        #FF4D4D
                    );
                    display:flex;
                    align-items:center;
                    justify-content:center;
                    font-size:30px;
                    margin-bottom:24px;
                        color: #fff;
                }

                .wcp-feature h3{
                    font-size:28px;
                    margin-bottom:14px;
                    color:#111;
                    font-family:'Syne',sans-serif;
                }

                .wcp-feature p{
                    color:#666;
                    line-height:1.8;
                    font-size:15px;
                }

                .wcp-glow{
                    position:absolute;
                    border-radius:50%;
                    filter:blur(120px);
                    opacity:.15;
                }

                .wcp-glow-1{
                    width:400px;
                    height:400px;
                    background:#E8212A;
                    left:-120px;
                    top:-120px;
                }

                .wcp-glow-2{
                    width:350px;
                    height:350px;
                    background:#FF4D4D;
                    right:-120px;
                    bottom:-120px;
                }

                @keyframes floatPhone{
                    0%,100%{
                        transform:translate(-50%,-50%) translateY(0);
                    }
                    50%{
                        transform:translate(-50%,-50%) translateY(-18px);
                    }
                }

                @keyframes floatCard{
                    0%,100%{
                        transform:translateY(0);
                    }
                    50%{
                        transform:translateY(-10px);
                    }
                }

                @media(max-width:1100px){

                    .wcp-container{
                        grid-template-columns:1fr;
                    }

                    .wcp-features{
                        grid-template-columns:1fr 1fr;
                    }

                }

                @media(max-width:768px){

                    .wcp-section{
                        padding:100px 18px;
                    }

                    .wcp-visual{
                        height:500px;
                    }

                    .wcp-phone{
                        width:240px;
                        height:500px;
                    }

                    .wcp-features{
                        grid-template-columns:1fr;
                    }

                    .wcp-content h2{
                        letter-spacing:-2px;
                    }

                }

            `}</style>

            </section>
        </>
    );
};

export default CrossPlatformHero;